import React, { useState, useEffect } from "react";
import axios from "axios";
import { banner_style } from "../Styles/styles";

const BrochureDownload = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    mobileNumber: "",
    address: "",
    state: "",
    country: "",
    university: "",
    email: "",
    affiliation: "",
    linkedin: "",
    twitter: "",
    interestedIn: "",
    websiteDomain: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  useEffect(() => {
    if (typeof window !== "undefined") {
      setForm((prevForm) => ({
        ...prevForm,
        websiteDomain: window.location.hostname,
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "", message: "" });

    try {
      // Send standard Form Data or JSON (Backend supports both, but let's use standard JSON/x-www-form-urlencoded format matching backend routes)
      const submitData = new FormData();
      Object.keys(form).forEach((key) => {
        submitData.append(key, form[key]);
      });

      const apiUrl = process.env.REACT_APP_BACKEND_URL;
      const res = await axios.post(
        `${apiUrl}/brochure-download`,
        submitData,
        {
          withCredentials: true,
        }
      );

      if (res.status === 200 || res.data?.success) {
        setStatus({
          type: "success",
          message: "Form submitted successfully! Your brochure download is starting now.",
        });

        // Trigger local brochure download of /QUANTUMTECH 2027.pdf
        const link = document.createElement("a");
        link.href = "/QUANTUMTECH 2027.pdf";
        link.setAttribute("download", "QUANTUMTECH 2027.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Reset form fields
        setForm({
          firstName: "",
          lastName: "",
          mobileNumber: "",
          address: "",
          state: "",
          country: "",
          university: "",
          email: "",
          affiliation: "",
          linkedin: "",
          twitter: "",
          interestedIn: "",
          websiteDomain: form.websiteDomain,
        });
      } else {
        setStatus({
          type: "error",
          message: res.data?.message || "Failed to submit form. Please try again.",
        });
      }
    } catch (err) {
      console.error(err);
      setStatus({
        type: "error",
        message:
          err.response?.data?.message ||
          err.message ||
          "Submission failed. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const presentationOptions = [
    "Quantum AI",
    "Core Quantum Science",
    "Machine Learning",
    "Cryptography & Cybersecurity",
    "Quantum Computation",
    "Optics & Photonics",
    "Software Development",
    "Communication & Networking",
    "Quantum Biology",
    "Quantum Sensing and Metrology",
    "Quantum Chemistry",
    "Modern Spectroscopy",
    "Quantum Applications",
    "Quantum Cosmology",
    "Materials & Devices",
    "Industry & Future",
    "Quantum Agriculture",
    "Quantum Education & Training",
    "Robotics & Automation",
  ];

  return (
    <div className="w-[90%] md:w-[80%] mx-auto p-4 mb-16">
      <div
        className={`${banner_style} w-full mx-auto brochure-banner`}
        style={{
          backgroundImage:
            "url('https://wallpapers.com/images/hd/4k-office-background-tw1rq5nwu7z2ou3w.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <h1 className="text-black-100 text-3xl sm:text-5xl md:text-6xl font-bold px-4">
          {/* Brochure Download */}
        </h1>
      </div>

      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-2xl p-6 md:p-10 border border-gray-100">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-extrabold text-gray-900">Download Brochure</h2>
          <p className="mt-2 text-sm text-gray-600">
            Please fill in your details below to access the conference brochure.
          </p>
        </div>

        {status.message && (
          <div
            className={`w-full p-4 rounded-xl text-white text-center mb-6 font-medium shadow-md transition-all duration-300 ${
              status.type === "success" ? "bg-green-600 animate-fade-in" : "bg-red-600 animate-shake"
            }`}
          >
            {status.message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex flex-col gap-1.5">
              <label htmlFor="firstName" className="text-sm font-semibold text-gray-700 text-left">
                First Name <span className="text-red-500">*</span>
              </label>
              <input
                id="firstName"
                name="firstName"
                value={form.firstName}
                onChange={handleChange}
                placeholder="Enter First Name"
                required
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one transition duration-200"
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="lastName" className="text-sm font-semibold text-gray-700 text-left">
                Last Name <span className="text-red-500">*</span>
              </label>
              <input
                id="lastName"
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
                placeholder="Enter Last Name"
                required
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one transition duration-200"
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="email" className="text-sm font-semibold text-gray-700 text-left">
                Email Address <span className="text-red-500">*</span>
              </label>
              <input
                id="email"
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter Email Address"
                required
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one transition duration-200"
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="mobileNumber" className="text-sm font-semibold text-gray-700 text-left">
                Mobile Number <span className="text-red-500">*</span>
              </label>
              <input
                id="mobileNumber"
                name="mobileNumber"
                value={form.mobileNumber}
                onChange={handleChange}
                placeholder="Enter Mobile Number"
                required
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one transition duration-200"
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="university" className="text-sm font-semibold text-gray-700 text-left">
                University / Industry <span className="text-red-500">*</span>
              </label>
              <input
                id="university"
                name="university"
                value={form.university}
                onChange={handleChange}
                placeholder="Enter University or Industry"
                required
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one transition duration-200"
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="affiliation" className="text-sm font-semibold text-gray-700 text-left">
                Affiliation <span className="text-red-500">*</span>
              </label>
              <input
                id="affiliation"
                name="affiliation"
                value={form.affiliation}
                onChange={handleChange}
                placeholder="Enter Affiliation (e.g. Student, Professor, Researcher)"
                required
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one transition duration-200"
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="address" className="text-sm font-semibold text-gray-700 text-left">
                Address <span className="text-red-500">*</span>
              </label>
              <input
                id="address"
                name="address"
                value={form.address}
                onChange={handleChange}
                placeholder="Enter Street Address"
                required
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one transition duration-200"
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="state" className="text-sm font-semibold text-gray-700 text-left">
                State <span className="text-red-500">*</span>
              </label>
              <input
                id="state"
                name="state"
                value={form.state}
                onChange={handleChange}
                placeholder="Enter State/Province"
                required
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one transition duration-200"
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="country" className="text-sm font-semibold text-gray-700 text-left">
                Country <span className="text-red-500">*</span>
              </label>
              <input
                id="country"
                name="country"
                value={form.country}
                onChange={handleChange}
                placeholder="Enter Country"
                required
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one transition duration-200"
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="interestedIn" className="text-sm font-semibold text-gray-700 text-left">
                Interested In <span className="text-red-500">*</span>
              </label>
              <select
                id="interestedIn"
                name="interestedIn"
                value={form.interestedIn}
                onChange={handleChange}
                required
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one bg-white transition duration-200 cursor-pointer"
              >
                <option value="">Select Presentation Track</option>
                {presentationOptions.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="linkedin" className="text-sm font-semibold text-gray-700 text-left">
                LinkedIn Profile URL <span className="text-gray-400 font-normal">(Optional)</span>
              </label>
              <input
                id="linkedin"
                name="linkedin"
                value={form.linkedin}
                onChange={handleChange}
                placeholder="Enter LinkedIn Profile Link"
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one transition duration-200"
              />
            </div>

            <div className="flex flex-col gap-1.5">
              <label htmlFor="twitter" className="text-sm font-semibold text-gray-700 text-left">
                Twitter Handle <span className="text-gray-400 font-normal">(Optional)</span>
              </label>
              <input
                id="twitter"
                name="twitter"
                value={form.twitter}
                onChange={handleChange}
                placeholder="Enter Twitter Handle (e.g. @username)"
                className="border border-gray-300 p-3.5 rounded-xl focus:outline-none focus:ring-2 focus:ring-one focus:border-one transition duration-200"
              />
            </div>
          </div>

          <div className="pt-4 flex justify-center">
            <button
              aria-label="button"
              type="submit"
              disabled={loading}
              className="bg-one text-white px-10 py-4 rounded-xl font-bold tracking-wide hover:shadow-lg transition duration-300 w-full md:w-auto cursor-pointer disabled:bg-gray-400 disabled:cursor-not-allowed hover:-translate-y-0.5 active:translate-y-0"
            >
              {loading ? "Submitting..." : "Submit & Download Brochure"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BrochureDownload;
